export default __webpack_public_path__ + "static/coSignerPicture-2efbca950d2677278ceeca009023f0c0.svg";